import HttpService from "./HttpService";
import Logger from "../Logger/Logger";
import {SERVER_URL} from "../../Config/Parameters";
import {ErrorCode, ThirtyOneError} from "../Error/ThirtyOneError";
import {powerClientRepository} from "../Repositories/PowerClientRepository";
import HttpResult from "../Models/HttpResult";
import {EXPIRED_TOKEN, POWER_ACTION_MESSAGES} from "../../Config/Translations";
import {userRepository} from "../Repositories/UserRepository";

const logger = Logger.Create('PowerActionService');

/**
 * The Power Client Service.
 */
export default class PowerActionService
{
    /**
     * Requests the server to wake the given power clients.
     */
    public static async wake(): Promise<HttpResult>
    {
        const currentlySelectedClients = powerClientRepository.currentlySelectedClients;
        const actionCallback: HttpResult = {
            success: false,
            message: "",
        };
        
        if (currentlySelectedClients.length < 1)
        {
            actionCallback.success = false;
            actionCallback.message = POWER_ACTION_MESSAGES.noClientSelected;
            return actionCallback;
        }
        
        const url = `${SERVER_URL}/action/wake`;
        
        const body = {
            "powerClientIds": currentlySelectedClients,
        }
        
        logger.info(`Requesting the server to wake clients ${JSON.stringify(body)}`);

        await HttpService.post(url, body)
            .then(() =>
            {
                logger.info(`Successfully requested the following clients to awake: ${JSON.stringify(currentlySelectedClients)}`)
                actionCallback.success = true;
                actionCallback.message = POWER_ACTION_MESSAGES.wakeSuccess;
                
            })
            .catch((error: ThirtyOneError) =>
            {
                actionCallback.success = false;
                
                if (error.errorCode !== ErrorCode.ExpiredToken)
                {
                    logger.error(`Request failed with error: ${error.message}`);
                    actionCallback.message = `${POWER_ACTION_MESSAGES.wakeFailed} ${error.message}`;
                    return;
                }

                // Session expired. Log user out.
                actionCallback.message = EXPIRED_TOKEN;
                userRepository.removeUserDetails();
            })
        
        return actionCallback;
    }

    /**
     * Requests the server to shutdown the given power clients.
     */
    public static async shutdown(): Promise<HttpResult>
    {
        const currentlySelectedClients = powerClientRepository.currentlySelectedClients;
        const actionCallback: HttpResult = {
            success: false,
            message: "",
        };
        
        if (currentlySelectedClients.length < 1)
        {
            actionCallback.success = false;
            actionCallback.message = POWER_ACTION_MESSAGES.noClientSelected;
            return actionCallback;
        }
        
        const url = `${SERVER_URL}/action/shutdown`;

        const body = {
            "powerClientIds": currentlySelectedClients,
        }

        logger.info(`Requesting the server to shutdown clients ${JSON.stringify(body)}`);

        await HttpService.post(url, body)
            .then(() =>
            {
                logger.info(`Successfully requested the following clients to shutdown: ${JSON.stringify(currentlySelectedClients)}`)
                actionCallback.success = true;
                actionCallback.message = POWER_ACTION_MESSAGES.shutdownSuccess;
            })
            .catch((error: ThirtyOneError) =>
            {
                actionCallback.success = false;

                if (error.errorCode !== ErrorCode.ExpiredToken)
                {
                    logger.error(`Request failed with error: ${error.message}`);
                    actionCallback.message = `${POWER_ACTION_MESSAGES.shutdownFailed} ${error.message}`;
                    return;
                }
                
                // Session expired. Log user out.
                actionCallback.message = EXPIRED_TOKEN;
                userRepository.removeUserDetails();
            })
        
        return actionCallback;
    }
}